export const heroSlides = [
  {
    id: "w06",
    title: "流星的约定",
    subtitle: "科幻爱情新作 · 跨越时间的信号与约定",
    tag: "正在热映",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20landscape%20of%20a%20dramatic%20meteor%20shower%20streaking%20across%20a%20deep%20navy%20night%20sky%20above%20a%20lone%20hilltop%20observatory%2C%20glowing%20warm%20meteor%20trails%20with%20orange%20accents%2C%20epic%20romantic%20sci-fi%20atmosphere%2C%20rich%20dark%20tones%20for%20text%20contrast%2C%20cinematic%20minimal%20composition&width=1600&height=900&seq=wk-hero-01&orientation=landscape",
  },
  {
    id: "w03",
    title: "樱花车站",
    subtitle: "治愈系剧集 · 四季流转间温柔的重逢与告别",
    tag: "口碑佳作",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20landscape%20of%20a%20quiet%20rural%20train%20station%20surrounded%20by%20blooming%20sakura%20trees%20in%20soft%20spring%20light%2C%20warm%20pink%20petals%20drifting%20against%20a%20pale%20cream%20sky%2C%20gentle%20romantic%20nostalgic%20mood%2C%20muted%20tones%20for%20text%20contrast%2C%20cinematic%20composition&width=1600&height=900&seq=wk-hero-02&orientation=landscape",
  },
  {
    id: "w01",
    title: "夜色钢琴曲",
    subtitle: "剧情音乐片 · 为这座城市写下最后一首曲子",
    tag: "编辑推荐",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20landscape%20of%20a%20lonely%20grand%20piano%20under%20a%20single%20warm%20spotlight%20in%20a%20vast%20dark%20empty%20theatre%20with%20deep%20navy%20blue%20shadows%20and%20amber%20glow%2C%20moody%20minimalist%20atmosphere%2C%20dark%20tones%20for%20text%20contrast%2C%20cinematic%20composition&width=1600&height=900&seq=wk-hero-03&orientation=landscape",
  },
  {
    id: "w10",
    title: "追光者",
    subtitle: "励志剧情片 · 在失去光明之前，记录最温柔的清晨",
    tag: "即将上映",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20landscape%20of%20a%20golden%20sunrise%20breaking%20over%20a%20misty%20city%20rooftop%20skyline%2C%20warm%20amber%20and%20deep%20blue%20gradient%20sky%2C%20hopeful%20inspiring%20atmosphere%2C%20soft%20haze%20for%20text%20contrast%2C%20minimalist%20cinematic%20composition&width=1600&height=900&seq=wk-hero-04&orientation=landscape",
  },
];